const AssignType = [
  "EQUAL_ALLOCATION", // 平均分配
  "EFFICIENCY_ALLOCATION", // 效率分配
  "EMPTY", // 占位
  "QUOTA_ALLOCATION", // 定额分配
];

const GradingTimes = [
  "EMPTY", // 占位
  "SINGLE", // 单批
  "DOUBLE" // 双批
];

const PauseStatus = [
  "NO", // 否
  "YES", // 是
];

const GradingStatus = [
  "NO_SETTING", // 未设置
  "NOT_GRADING", // 未批阅
  "GRADING", // 批阅
  "PAUSE_GRADING", // 暂停批阅
  "GRADING_DONE", // 结束批阅
];

const AssignMode = [
  "VERSION_2", // 原版2.0使用
  "TEACHER", // 按老师分配
  "SCHOOL", // 按学校分配
  "CLASS", // 按班级分配
];

const MarkType = [
  "",
  "FIRST",
  "SECOND",
  "THIRD",
  "LEADER"
]

export default Object.freeze({
  AssignType,
  GradingTimes,
  PauseStatus,
  GradingStatus,
  AssignMode,
  MarkType
})